import { CqrsService } from '@common/services/cqrs.service';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '@common/services/common.service';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { DialogService } from '@services/dialog.service';

@Component({
    selector: 'app-add-proposed-berth',
    templateUrl: './add-proposed-berth.component.html',
    styleUrls: ['./add-proposed-berth.component.scss'],
})
export class AddProposedBerthComponent implements OnInit {
    model: any = {};
    accommodationRequestId: number;

    isBusy = false;
    faSpinner = faSpinner;

    constructor(
        public activeModal: NgbActiveModal, 
        private cqrs: CqrsService,
        protected common: CommonService,
        private toastrService: ToastrService,
        protected translateService: TranslateService,
        private dialogService: DialogService,
    ) { }

    ngOnInit(): void {
        
    }

    async confirm() {            
        this.model.accommodationRequestId = this.accommodationRequestId;  
        this.model.accepted = null;        

        this.activeModal.close(this.model); 
    }

    get isValid(): boolean {
        return !this.model.berthId ||
            !this.model.agentNote;
    }
}
